import { render } from "./StorefrontImg.vue?vue&type=template&id=51c7d341"
import script from "./StorefrontImg.vue?vue&type=script&lang=js"
export * from "./StorefrontImg.vue?vue&type=script&lang=js"

import "./StorefrontImg.vue?vue&type=style&index=0&id=51c7d341&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__